/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.pagination[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] {\r\n  cursor: pointer;\r\n  color: black;\r\n}\r\n\r\n.pagination[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] {\r\n  cursor: pointer;\r\n  background: #2ea7e0;\r\n  color: #fff;\r\n  border: 1px solid transparent;\r\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3BhZ2luYXRpb24vcGFnaW5hdGlvbi5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL2hhbWFkYS9Eb2N1bWVudHMvZ2l0X3ZlcmlmeS9rdXJ1bWFqaXRlbl9hb3Qva3VydW1haml0ZW4vc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9wYWdpbmF0aW9uL3BhZ2luYXRpb24uY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/pagination/pagination.component.css.shim.ngstyle.ts